var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.66663 3.74995C1.66663 3.41843 1.79205 3.10048 2.01531 2.86606C2.23857 2.63164 2.54137 2.49995 2.8571 2.49995H17.1428C17.4585 2.49995 17.7614 2.63164 17.9846 2.86606C18.2079 3.10048 18.3333 3.41843 18.3333 3.74995C18.3333 4.08147 18.2079 4.39941 17.9846 4.63383C17.7614 4.86825 17.4585 4.99995 17.1428 4.99995H2.8571C2.54137 4.99995 2.23857 4.86825 2.01531 4.63383C1.79205 4.39941 1.66663 4.08147 1.66663 3.74995ZM4.2899 9.99995C4.2899 9.66843 4.41532 9.35048 4.63858 9.11606C4.86184 8.88164 5.16464 8.74995 5.48037 8.74995H14.5774C14.8932 8.74995 15.196 8.88164 15.4192 9.11606C15.6425 9.35048 15.7679 9.66843 15.7679 9.99995C15.7679 10.3315 15.6425 10.6494 15.4192 10.8838C15.196 11.1182 14.8932 11.2499 14.5774 11.2499H5.48037C5.16464 11.2499 4.86184 11.1182 4.63858 10.8838C4.41532 10.6494 4.2899 10.3315 4.2899 9.99995ZM7.34966 16.4152C7.34966 16.0837 7.47509 15.7658 7.69834 15.5313C7.9216 15.2969 8.2244 15.1652 8.54014 15.1652H11.52C11.8357 15.1652 12.1385 15.2969 12.3618 15.5313C12.5851 15.7658 12.7105 16.0837 12.7105 16.4152C12.7105 16.7467 12.5851 17.0647 12.3618 17.2991C12.1385 17.5335 11.8357 17.6652 11.52 17.6652H8.54014C8.2244 17.6652 7.9216 17.5335 7.69834 17.2991C7.47509 17.0647 7.34966 16.7467 7.34966 16.4152Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_891_7488)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Fill",
  x: 0.0032959,
  y: -0.000686646,
  width: 20,
  height: 20,
  fill: "#00538F"
}));

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Filter"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_891_7488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 16
  }, _ref2), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.32d1a0bc.svg";
export { ForwardRef as ReactComponent };